import * as React from "react";
const SvgFiRrJoint = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.5 17H6.971C3.745 17 .579 19.079.447 19.167a1 1 0 0 0 .002 1.667C.583 20.922 3.765 23 6.971 23H21.5c1.378 0 2.5-1.122 2.5-2.5v-1c0-1.378-1.122-2.5-2.5-2.5m-9.086 4-2-2h4.172l2 2zm-9.32-1.003C4.136 19.514 5.572 19 6.971 19h.615l2 2H6.971c-1.386 0-2.829-.518-3.877-1.003M22 20.5a.5.5 0 0 1-.5.5h-2.086l-2-2H21.5a.5.5 0 0 1 .5.5zM13 4.856V3a1 1 0 0 1 2 0v1.856c0 1.047.558 2.033 1.457 2.573l1.602.961a4.02 4.02 0 0 1 1.942 3.43V14a1 1 0 0 1-2 0v-2.18a2.01 2.01 0 0 0-.971-1.715l-1.602-.961a5.03 5.03 0 0 1-2.427-4.288zm11 5.408v1.735a1 1 0 0 1-2 0v-1.735a3.01 3.01 0 0 0-1.457-2.572L18.456 6.44a3.02 3.02 0 0 1-1.457-2.572V1a1 1 0 0 1 2 0v2.868c0 .349.186.678.485.857l2.087 1.252a5.02 5.02 0 0 1 2.427 4.287z"
    />
  </svg>
);
export default SvgFiRrJoint;
